import DepositSelect from './Select';
import useDeposit from './useDeposit';

const Deposit: React.FunctionComponent = function () {
  const { depositField } = useDeposit();
  if (depositField !== 'select') return null;
  return (
    <>
      <div className="mt-8" />
      <DepositSelect />
    </>
  );
};

export default Deposit;
